import {
  Checkbox as MantineCheckbox,
  CheckboxProps as MantineCheckboxProps,
} from "@mantine/core"
import { forwardRef } from "react"

import { buildLabel } from "../utils"

export type CheckboxProps = Omit<MantineCheckboxProps, "component"> & {
  isLoading?: boolean
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, isLoading, required, ...props }, ref) => {
    const finalLabel = buildLabel(label, isLoading, required)

    return <MantineCheckbox ref={ref} label={finalLabel} {...props} />
  }
)

Checkbox.displayName = "Checkbox"
